import { jsx as _jsx } from "react/jsx-runtime";
import SvgCheckmark from '../icons/SvgCheckmark';
const DoneIcon = () => {
    return (_jsx("div", { className: "relative top-2 left-05 inline-block text-left", children: _jsx(SvgCheckmark, { className: "text-white h-4 w-4 fill-current" }) }));
};
export default DoneIcon;
